import React from 'react'
import { Heading , Text, Tag } from 'base-ui'
import Highlighter from './Highlight'
import { Tag as TagExample } from '../examples/Tag'
import { PageWrapper } from './PageWrapper'
import { IconAward } from '@paro.io/base-icons'

const Tags = () => {
  const onTagClick = (selectedTag: number | string)=>{
    console.info(selectedTag)
  }
  return (
    <PageWrapper title="Tags">
      <Text size="lg">
      Tags are used for items that need to be labeled, categorized, or organized using keywords that describe them.
      </Text>
      <div className="py-4">
        <div className="space-x-2">
          <Tag label="Tag Default or Neutral" variant="solid" value={1} onClick={onTagClick}/>
          <Tag label="Tag Primary" value={4} color="primary" variant="solid"/>
        </div>
      </div>
      
      <Heading size="h3">Variants</Heading>
      <div className="py-4">
        <div className="space-x-4">
        <Tag label="Tag Default or Neutral" value={2} color="default" variant="solid" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="primary" variant="solid" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="info" variant="solid" onClick={onTagClick}/>
          <Tag label="Tag Warning" value={3} color="warning" variant="solid" onClick={onTagClick}/>
          <Tag label="Tag Success" value={4} color="success" variant="solid"/>
          <Tag label="Tag Danger" value={4} color="danger" variant="solid"/>
        </div>
        <div className="space-x-4 mt-1">
          <Tag label="Tag Default or Neutral" value={2} color="default" variant="subtle" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="primary" variant="subtle" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="info" variant="subtle" onClick={onTagClick}/>
          <Tag label="Tag Warning" value={3} color="warning" variant="subtle" onClick={onTagClick}/>
          <Tag label="Tag Success" value={4} color="success" variant="subtle"/>
          <Tag label="Tag Danger" value={4} color="danger" variant="subtle"/>
        </div>
        <div className="space-x-4 mt-1">
          <Tag label="Tag Default or Neutral" value={2} color="default" variant="outline" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="primary" variant="outline" onClick={onTagClick}/>
          <Tag label="Tag Info" value={2} color="info" variant="outline" onClick={onTagClick}/>
          <Tag label="Tag Warning" value={3} color="warning" variant="outline" onClick={onTagClick}/>
          <Tag label="Tag Success" value={4} color="success" variant="outline"/>
          <Tag label="Tag Danger" value={4} color="danger" variant="outline"/>
        </div>
      </div>

      <Heading size="h3">With Custom Radius</Heading>
      <div className="py-4">
        <div className="space-x-4">
          <Tag label="Tag radius full" value={2} color="primary" variant="outline" borderRadius="full" onClick={onTagClick}/>
          <Tag label="Tag radius left" value={2} color="primary" variant="outline" borderRadius="l" onClick={onTagClick}/>
          <Tag label="Tag radius right" value={3} color="primary" variant="outline" borderRadius="r" onClick={onTagClick}/>
        </div>
      </div>

      <Heading size="h3">With Icons</Heading>
      <div className="py-4">
        <div className="space-x-2">
          <Tag 
            label="Tag left icon"
            variant='solid'
            color='primary'
            iconLeft={<IconAward size="sm" />}
            value={6} />
            <Tag 
            label="Tag right icon" 
            variant='subtle'
            color='info'
            iconRight={<IconAward size="sm" />}
            value={6} />          
        </div>
      </div>

      <Heading size="h3">Usage</Heading>
      <Highlighter code={TagExample} language='jsx' />
    </PageWrapper>
  )
}

export default Tags
